import React from 'react';

const PrintOrder = ({ order }) => {
  const groupOrderItems = (items) => {
    const grouped = {};
    
    items.forEach(item => {
      const key = `${item.reference}-${item.model_name}-${item.color}`;
      
      if (!grouped[key]) {
        grouped[key] = {
          reference: item.reference,
          model_name: item.model_name,
          color: item.color,
          ean: item.ean,
          sizes: [],
          totalPairs: 0,
          subtotal: 0
        };
      }
      
      grouped[key].sizes.push({
        size: item.size,
        quantity: item.quantity,
        price: item.price
      });
      grouped[key].totalPairs += item.quantity;
      grouped[key].subtotal += item.price * item.quantity;
    });
    
    return Object.values(grouped);
  };

  const groupedItems = groupOrderItems(order.items);

  return (
    <div className="print-order-container">
      <style>{`
        @media print {
          body * {
            visibility: hidden;
          }
          .print-order-container,
          .print-order-container * {
            visibility: visible;
          }
          .print-order-container {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
          }
          .no-print {
            display: none !important;
          }
        }

        .print-order-container {
          max-width: 800px;
          margin: 0 auto;
          padding: 40px;
          font-family: Arial, sans-serif;
          background: white;
        }

        .print-header {
          text-align: center;
          margin-bottom: 30px;
          padding-bottom: 20px;
          border-bottom: 3px solid #000;
        }

        .print-header h1 {
          font-size: 32px;
          margin: 0 0 10px 0;
          color: #000;
        }

        .print-order-info {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 20px;
          margin-bottom: 30px;
          padding: 20px;
          background: #f8f9fa;
          border-radius: 8px;
        }

        .print-info-section h3 {
          font-size: 14px;
          color: #666;
          margin: 0 0 10px 0;
          text-transform: uppercase;
        }

        .print-info-section p {
          margin: 5px 0;
          font-size: 16px;
          color: #000;
        }

        .print-items {
          margin-bottom: 30px;
        }

        .print-items h2 {
          font-size: 20px;
          margin-bottom: 20px;
          color: #000;
          border-bottom: 2px solid #000;
          padding-bottom: 10px;
        }

        .print-item {
          padding: 20px;
          margin-bottom: 15px;
          border: 1px solid #ddd;
          border-radius: 4px;
          page-break-inside: avoid;
        }

        .print-item-header {
          margin-bottom: 10px;
        }

        .print-item-title {
          font-size: 18px;
          font-weight: bold;
          margin: 0 0 5px 0;
        }

        .print-item-ref {
          font-size: 14px;
          color: #0066cc;
          margin: 0;
        }

        .print-item-sizes {
          font-size: 14px;
          margin: 10px 0;
          color: #333;
        }

        .print-item-total {
          display: flex;
          justify-content: space-between;
          font-size: 16px;
          margin-top: 10px;
          padding-top: 10px;
          border-top: 1px dashed #ccc;
        }

        .print-total-section {
          margin-top: 30px;
          padding: 20px;
          background: #f8f9fa;
          border-radius: 8px;
        }

        .print-total-row {
          display: flex;
          justify-content: space-between;
          padding: 10px 0;
          font-size: 18px;
        }

        .print-total-final {
          font-size: 24px;
          font-weight: bold;
          border-top: 2px solid #000;
          padding-top: 15px;
          margin-top: 10px;
        }

        .print-footer {
          margin-top: 40px;
          text-align: center;
          font-size: 12px;
          color: #666;
          border-top: 1px solid #ddd;
          padding-top: 20px;
        }
      `}</style>

      <div className="print-header">
        <h1>HI-TEC B2B</h1>
        <p style={{ fontSize: '16px', margin: 0, color: '#666' }}>Pedido de Producto</p>
      </div>

      <div className="print-order-info">
        <div className="print-info-section">
          <h3>Información del Pedido</h3>
          <p><strong>Nº Pedido:</strong> {order.order_number}</p>
          <p><strong>Estado:</strong> {order.status === 'pending' ? 'Pendiente' : order.status === 'confirmed' ? 'Confirmado' : order.status}</p>
          <p><strong>Fecha:</strong> {new Date(order.created_at).toLocaleDateString('es-ES', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
          })}</p>
          {order.delivery_date && (
            <p><strong>Entrega:</strong> {new Date(order.delivery_date).toLocaleDateString('es-ES', {
              year: 'numeric',
              month: 'long',
              day: 'numeric'
            })}</p>
          )}
        </div>

        <div className="print-info-section">
          <h3>Información del Cliente</h3>
          <p><strong>Empresa:</strong> {order.business_name}</p>
          <p><strong>Email:</strong> {order.user_email}</p>
          {order.observations && (
            <p><strong>Observaciones:</strong> {order.observations}</p>
          )}
        </div>
      </div>

      <div className="print-items">
        <h2>Detalles del Pedido</h2>
        {groupedItems.map((group, index) => (
          <div key={index} className="print-item">
            <div className="print-item-header">
              <p className="print-item-title">{group.model_name}</p>
              <p className="print-item-ref">
                REF: {group.reference} | Color: {group.color}
              </p>
            </div>
            <div className="print-item-sizes">
              <strong>Tallas:</strong>{' '}
              {group.sizes
                .sort((a, b) => parseFloat(a.size) - parseFloat(b.size))
                .map(s => `${s.size} (${s.quantity})`)
                .join(', ')}
            </div>
            <div className="print-item-total">
              <span><strong>Total pares:</strong> {group.totalPairs}</span>
              <span><strong>Subtotal:</strong> €{group.subtotal.toFixed(2)}</span>
            </div>
          </div>
        ))}
      </div>

      <div className="print-total-section">
        <div className="print-total-row">
          <span>Subtotal:</span>
          <span>€{order.total.toFixed(2)}</span>
        </div>
        <div className="print-total-row print-total-final">
          <span>TOTAL:</span>
          <span>€{order.total.toFixed(2)}</span>
        </div>
      </div>

      <div className="print-footer">
        <p>HI-TEC B2B Platform - www.hitec.com</p>
        <p>Para cualquier consulta, contacte con su representante de ventas</p>
      </div>
    </div>
  );
};

export default PrintOrder;
